import { render } from "./MyAgreementsModal.vue?vue&type=template&id=65bd86bb"
import script from "./MyAgreementsModal.vue?vue&type=script&lang=js"
export * from "./MyAgreementsModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__